/** A synchronous gate closes the render gap before React can disable a submit button. */
export function createSettingsOperation() {
  let pending = false;
  return {
    get pending() {
      return pending;
    },
    async run<T>(action: () => Promise<T>): Promise<T | undefined> {
      if (pending) return undefined;
      pending = true;
      try {
        return await action();
      } finally {
        pending = false;
      }
    },
  };
}

export type SettingsDraftState = { dirty: boolean; pending: boolean };

export function hasSettingsDraft(states: Iterable<SettingsDraftState>) {
  for (const state of states) if (state.dirty || state.pending) return true;
  return false;
}
